import React from 'react'

export const Container = ({ children }) => <div className="uk-container">{ children }</div>


// WEBPACK FOOTER //
// ./src/ui/elements/Container.js